module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('h1', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32e18503"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Block.vue
// module id = 292
// module chunks = 1